import { render, staticRenderFns } from "./NewDefaultView.vue?vue&type=template&id=b8b12bce"
import script from "./NewDefaultView.vue?vue&type=script&lang=js"
export * from "./NewDefaultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports